/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { RecordScope } from './RecordScope';

export type RecordCreateRequest = {
  uuid?: string | null;
  source: RecordCreateRequest.source;
  upload_source?: RecordCreateRequest.upload_source;
  title?: string | null;
  duration?: number | string | null;
  filesize: number;
  /**
   * 녹음/녹화 종료 시간
   */
  rec_date: string;
  team_ids?: Array<number> | null;
  transcribe_language?:
    | 'detect'
    | 'multi'
    | 'ko'
    | 'en'
    | 'ja'
    | 'zh'
    | 'es'
    | 'fr'
    | 'de'
    | 'ru'
    | 'pt'
    | 'it'
    | 'ar'
    | 'hi'
    | 'id'
    | 'vi'
    | 'th'
    | 'nl'
    | string;
  scope: RecordScope;
  accessible_team_ids?: Array<number> | null;
  accessible_user_ids?: Array<number> | null;
  save_media?: boolean | string;
  save_dialog?: boolean | string;
};

export namespace RecordCreateRequest {
  export enum source {
    VOICE_RECORDER = 'voice_recorder',
    SCREEN_RECORDER = 'screen_recorder',
    MANUAL_UPLOAD = 'manual_upload',
    PHONE_CALL = 'phone_call',
  }

  export enum upload_source {
    UNKNOWN = 'unknown',
    ANDROID = 'android',
    IOS = 'ios',
    WEB = 'web',
  }
}
